import { CSSProperties, ReactNode } from "react";
import { Button, Col, Row } from "reactstrap";

interface AppPageHeaderProps {
  title: ReactNode;
  breadcrumbs?: ReactNode;
  description: string | ReactNode;
  action?: () => void;
  actionButtonName?: string;
  actionButtonColor?: string;
  customContent?: ReactNode;
  disabled?: boolean;
  style?: CSSProperties;
  size?: string;
  titleBreakpoints?: object;
  actionsBreakpoints?: object;
  borderless?: boolean;
  fullWidth?: boolean;
  rowClass?: string;
  actionClass?: string;
  className?: string;
}

const AppPageHeader = ({
  title,
  breadcrumbs,
  description,
  action,
  actionButtonName,
  actionButtonColor = "primary",
  customContent, // Any content to be rendered in the header
  disabled,
  style,
  size,
  titleBreakpoints = { xs: "auto" },
  actionsBreakpoints = { xs: "auto" },
  borderless = false,
  fullWidth = false,
  rowClass,
  actionClass = "",
  className = "",
}: AppPageHeaderProps) => {
  return (
    <div
      style={style}
      className={`overflow-hidden ${
        size === "sm"
          ? `${fullWidth && "w-100"}`
          : `mt-4 mb-3 pb-3 ${fullWidth && "w-100"} ${
              borderless ? "" : "border-bottom"
            }`
      } ${className}`}
    >
      <Row className={`align-items-center justify-content-between ${rowClass}`}>
        <Col {...titleBreakpoints}>
          {size === "sm" ? (
            <div>
              <h4 className="mb-0">{title}</h4>
              <small>{description}</small>
              {breadcrumbs && breadcrumbs}
            </div>
          ) : (
            <>
              <h2 className={description ? "mb-1" : "mb-0"}>
                {title || "Manage Tags"}
              </h2>

              {description && (
                <>
                  <p className="small mb-0">{description}</p>
                </>
              )}
              {breadcrumbs && breadcrumbs}
            </>
          )}
        </Col>
        <Col {...actionsBreakpoints} className={actionClass}>
          {action ? (
            <Button
              onClick={action}
              color={actionButtonColor}
              disabled={disabled}
              size={size}
              style={{ minWidth: 80 }}
            >
              {actionButtonName}
            </Button>
          ) : (
            customContent
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AppPageHeader;
